export default __webpack_public_path__ + "src/assets/icn-separator.f7a5b7bb6c1b2966f13e29dfe4d66a72.svg";